/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Search_Guides_Gridcraft_Vs_Excel_TagInputs */

const en_gc_search_guides_gridcraft_vs_excel_tag = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Vs_Excel_TagInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Product comparison`)
};

const zh_gc_search_guides_gridcraft_vs_excel_tag = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Vs_Excel_TagInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`产品对比`)
};

/**
* | output |
* | --- |
* | "Product comparison" |
*
* @param {Gc_Search_Guides_Gridcraft_Vs_Excel_TagInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_search_guides_gridcraft_vs_excel_tag = /** @type {((inputs?: Gc_Search_Guides_Gridcraft_Vs_Excel_TagInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Search_Guides_Gridcraft_Vs_Excel_TagInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_search_guides_gridcraft_vs_excel_tag(inputs)
	return zh_gc_search_guides_gridcraft_vs_excel_tag(inputs)
});
export { gc_search_guides_gridcraft_vs_excel_tag as "gc.search_guides.gridcraft_vs_excel.tag" }